import * as coreClient from "@azure/core-client";

export const AddressSearchRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AddressSearchRequest",
    modelProperties: {
      searchText: {
        serializedName: "searchText",
        required: true,
        type: {
          name: "String"
        }
      },
      session: {
        serializedName: "session",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AddressSearchResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AddressSearchResponse",
    modelProperties: {
      searchResults: {
        serializedName: "searchResults",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AddressSearchResult"
            }
          }
        }
      },
      count: {
        serializedName: "count",
        type: {
          name: "Number"
        }
      },
      session: {
        serializedName: "session",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AddressSearchResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AddressSearchResult",
    modelProperties: {
      label: {
        serializedName: "label",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "String"
        }
      },
      container: {
        serializedName: "container",
        type: {
          name: "Boolean"
        }
      },
      items: {
        serializedName: "items",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SearchDrillDownRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SearchDrillDownRequest",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AddressRetrieveRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AddressRetrieveRequest",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const AddressResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AddressResponse",
    modelProperties: {
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      location: {
        serializedName: "location",
        type: {
          name: "Composite",
          className: "Location"
        }
      }
    }
  }
};

export const Address: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Address",
    modelProperties: {
      line1: {
        serializedName: "line1",
        type: {
          name: "String"
        }
      },
      line2: {
        serializedName: "line2",
        type: {
          name: "String"
        }
      },
      line3: {
        serializedName: "line3",
        type: {
          name: "String"
        }
      },
      postcode: {
        serializedName: "postcode",
        type: {
          name: "String"
        }
      },
      townCity: {
        serializedName: "town_city",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Location: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Location",
    modelProperties: {
      districtCode: {
        serializedName: "districtCode",
        type: {
          name: "String"
        }
      },
      district: {
        serializedName: "district",
        type: {
          name: "String"
        }
      },
      wardCode: {
        serializedName: "wardCode",
        type: {
          name: "String"
        }
      },
      ward: {
        serializedName: "ward",
        type: {
          name: "String"
        }
      }
    }
  }
};
